import React from 'react';
import { ArrowLeftIcon, SearchIcon, BellIcon, UserIcon, ChevronDownIcon, CalendarIcon, BarChart3Icon, HelpCircleIcon } from 'lucide-react';
export function Header({
  title = 'Warehouse',
  hasBackButton = true,
  hasCreateButton = true,
  createButtonText = 'Create warehouse',
  onCreateClick,
  icon = null,
  subtitle = 'Manage warehouse inventory and details'
}) {
  return <header className="bg-gradient-to-br from-slate-900 via-blue-950 to-indigo-950 border-b border-blue-800/30 relative z-10" data-id="element-3398" data-mp="2rm5hns2v8ydy">
      <div className="px-6 py-4 flex justify-between items-center" data-id="element-3399" data-mp="2wkgr41p916vn">
        <div className="flex items-center" data-id="element-3400" data-mp="31bysgqv6p9h5">
          {hasBackButton && <ArrowLeftIcon className="mr-3 text-blue-300 hover:text-white cursor-pointer transition-colors" size={20} data-id="element-3401" data-mp="31cgw48k6epz3" />}
          <div className="p-2 mr-3 bg-gradient-to-br from-blue-600 to-indigo-700 rounded-lg" data-id="element-3402" data-mp="36d4qn47m5oy2">
            {icon || <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-white" data-id="element-3403" data-mp="3b8bnbs2gttdh">
                <path d="M6 19h12a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2z" data-id="element-3404" data-mp="2rm1a34vdry7p"></path>
                <path d="M12 4v4" data-id="element-3405" data-mp="2mmezl36xsw2l"></path>
                <path d="M3 10h18" data-id="element-3406" data-mp="2mn6sg695gfp6"></path>
                <path d="M6 14h.01" data-id="element-3407" data-mp="2hnlil0sfymxo"></path>
                <path d="M6 18h.01" data-id="element-3408" data-mp="2hon27tniwhr0"></path>
                <path d="M13 14h5" data-id="element-3409" data-mp="2hpy7xz0j3zkr"></path>
                <path d="M13 18h5" data-id="element-3410" data-mp="3fblvduf0b7k5"></path>
              </svg>}
          </div>
          <div data-id="element-3411" data-mp="3aciywyd3e9ns">
            <h1 className="text-xl font-bold text-white" data-id="element-3412" data-mp="3abps5xe4vk5n">{title}</h1>
            <p className="text-blue-200 text-sm hidden sm:block" data-id="element-3413" data-mp="3aelppkm2k6tk">{subtitle}</p>
          </div>
        </div>
        <div className="flex items-center space-x-3" data-id="element-3414" data-mp="30mfw66g65hc9">
          <div className="relative hidden sm:block" data-id="element-3415" data-mp="30lwpjlvyyfdj">
            <div className="relative" data-id="element-3416" data-mp="1w62f8co8jvc">
              <input type="text" placeholder="Search..." className="bg-white/10 border border-blue-800/30 rounded-full pl-10 pr-4 py-2 text-white placeholder-blue-300 focus:outline-none focus:ring-2 focus:ring-blue-500 w-56" data-id="element-3417" data-mp="1x7kvxw0o8n3" />
              <SearchIcon className="absolute left-3 top-1/2 transform -translate-y-1/2 text-blue-300" size={18} data-id="element-3418" data-mp="1rfo0djyq89d7" />
            </div>
          </div>
          <button className="p-2 text-blue-300 hover:text-white rounded-full hover:bg-white/10 transition-colors" data-id="element-3419" data-mp="1hojlslcyqqiw">
            <CalendarIcon size={20} data-id="element-3420" data-mp="1mljtf0pgo1c4" />
          </button>
          <button className="p-2 text-blue-300 hover:text-white rounded-full hover:bg-white/10 transition-colors" data-id="element-3421" data-mp="18n3fopt6lakh">
            <BarChart3Icon size={20} data-id="element-3422" data-mp="1cp6rxgnocj6t" />
          </button>
          <button className="p-2 text-blue-300 hover:text-white rounded-full hover:bg-white/10 transition-colors" data-id="element-3423" data-mp="1cmkkdh0sa3ol">
            <HelpCircleIcon size={20} data-id="element-3424" data-mp="13nz3rrevgyqg" />
          </button>
          <div className="relative" data-id="element-3425" data-mp="13oin9ck67v6l">
            <button className="p-2 text-blue-300 hover:text-white rounded-full hover:bg-white/10 transition-colors" data-id="element-3426" data-mp="13ptnx3ibkmth">
              <BellIcon size={20} data-id="element-3427" data-mp="2y1rraoty6ohg" />
              <span className="absolute -top-1 -right-1 w-4 h-4 bg-red-500 rounded-full text-xs flex items-center justify-center text-white" data-id="element-3428" data-mp="2y0p0egwmkm1j">
                2
              </span>
            </button>
          </div>
          <div className="flex items-center bg-white/10 hover:bg-white/15 rounded-full pl-2 pr-3 py-1 cursor-pointer transition-colors" data-id="element-3429" data-mp="hheks1tqvq3x">
            <div className="bg-gradient-to-br from-blue-600 to-indigo-700 rounded-full w-8 h-8 flex items-center justify-center mr-2" data-id="element-3430" data-mp="re13ajylm52s">
              <UserIcon size={16} className="text-white" data-id="element-3431" data-mp="1544gklfi2og3" />
            </div>
            <span className="text-white text-sm font-medium hidden sm:block" data-id="element-3432" data-mp="106kw33s7lffp">
              Daniel Alejandro
            </span>
            <ChevronDownIcon size={16} className="text-blue-300 ml-1 hidden sm:block" data-id="element-3433" data-mp="1f20ufkztnxhw" />
          </div>
          {hasCreateButton && <button onClick={onCreateClick} className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg transition-colors shadow-lg" data-id="element-3434" data-mp="1a50pjdepl0sd">
              {createButtonText}
            </button>}
        </div>
      </div>
    </header>;
}